import React from "react"
import styled from "styled-components"
import { css } from "../styles/GlobalStyles"

import ProfileView from "./ProfileView"
import Carousel from "../components/Carousel"
import CarouselTab from "../components/CarouselTab"
import ExperienceView from "./ExperienceView"
import SkillsView from "./SkillsView"
import PersonalView from "./PersonalView"

const StyledHome = styled.div`  
  width: var(--layout-width);
  display: flex;
  flex-direction: column;

  @media (min-width: ${css.breakpoints.split}) {
    flex-direction: row;
  }
`

const leftTab: CarouselTab = {
  header: "Experience",
  body: <ExperienceView />
}

const centerTab: CarouselTab = {
  header: "Skills",
  body: <SkillsView />
}

const rightTab: CarouselTab = {
  header: "Personal",
  body: <PersonalView />
}

const HomeView = () => {
  return (
    <StyledHome>
      <ProfileView />
      <Carousel
        left={leftTab}
        center={centerTab}
        right={rightTab}
      />
    </StyledHome>
  )
}

export default HomeView